<!-- Message Form at Top (if messagingBoxLocation is 'top') -->
<div
  *ngIf="messagingBoxLocation === 'top' && isInlineMessageFormVisible && !(1 | isReadonlyRole) && inquiry"
  class="message-form-top"
>
  <ng-template [ngTemplateOutlet]="messageFormTmpl" [ngTemplateOutletContext]="{ minWidth: null }"></ng-template>
</div>

<!-- Header -->
<div *ngIf="hasHeader" class="border-bottom p-3">
  <div class="d-flex align-items-center">
    <div class="text-bold" i18n>Previous Messages</div>
    <div class="flex-fill"></div>
    <div class="">
      <app-table-search (search)="searchTerm$.next($event)"> </app-table-search>
    </div>
  </div>
</div>

<app-empty-table *ngIf="!messages?.length" [type]="tableType"> </app-empty-table>

<div
  class="d-flex flex-column gap-4 p-3"
  [ngClass]="{ 'form-visible': isInlineMessageFormVisible }"
  *ngIf="messages?.length"
  style="overflow-x: auto; overflow-y: hidden"
>
  <ng-container *ngIf="incidentsFromMessages$ | async as incidents">
    <div class="d-flex align-items-center gap-2 bg-secondary-warning p-2 rounded" *ngIf="incidents.length">
      <span class="badge badge-circle badge-warning" style="--size: 1rem">
        {{ incidents.length }}
      </span>
      <span class="text-warning"
        >Al has created <span class="text-dark text-bold">{{ incidents.length }}</span> incidents and there are
        <span class="text-dark text-bold">{{ (draftTasksForBooking$ | async)?.length || 0 }}</span> pending tasks
        awaiting your approval.</span
      >
      <div class="flex-fill"></div>
      <a href="javascript:;" (click)="onOpenTaskApproval()" i18n>Click Here</a>
    </div>
  </ng-container>

  <app-message-list-item
    #msg
    *ngFor="let message of filteredMessages; let i = index; trackBy: trackByMessageId"
    [attr.id]="message.messageId"
    [message]="message"
    [collapsed]="isMessageCollapsed(i)"
    [hasMove]="hasMove"
    [inquiry]="inquiry"
    (editDraft)="onEditDraft($event)"
    (aiGenerate)="onAIGenerate($event)"
  ></app-message-list-item>
</div>

<!-- Message Form at Bottom (if messagingBoxLocation is 'bottom') -->
<div
  *ngIf="messagingBoxLocation === 'bottom' && isInlineMessageFormVisible && !(1 | isReadonlyRole) && inquiry"
  class="message-form-bottom"
>
  <ng-template [ngTemplateOutlet]="messageFormTmpl" [ngTemplateOutletContext]="{ minWidth: null }"></ng-template>
</div>

<!-- Reply button with floating form (only for 'closed' mode) -->
<ng-container *ngIf="!(1 | isReadonlyRole) && inquiry">
  <ng-container *ngIf="messagingBoxLocation === 'closed' || !isInlineMessageFormVisible">
    <button
      (click)="openMessageForm()"
      *ngIf="getViewRect() as rect"
      i18n-matTooltip
      matTooltip="Reply"
      matTooltipPosition="left"
      class="btn btn-secondary-info btn-circle text-xxl btn-reply position-fixed"
      type="button"
      cdkOverlayOrigin
      #trigger="cdkOverlayOrigin"
      [ngStyle]="{
        'left.px': rect.left + rect.width - 60,
        bottom: '20px'
      }"
    >
      <i class="fal fa-envelope"></i>
      <ng-container *ngIf="messagingBoxLocation === 'closed'">
        <ng-template
          cdkConnectedOverlay
          #inlineOverlayRef="cdkConnectedOverlay"
          [cdkConnectedOverlayOffsetX]="15"
          [cdkConnectedOverlayOffsetY]="5"
          [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'bottom' }]"
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="isInlineMessageFormVisible"
          [cdkConnectedOverlayDisableClose]="true"
          [cdkConnectedOverlayPanelClass]="isInlineMessageFormVisible && isInbox ? 'message-form-inline-overlay' : ''"
        >
          <ng-template
            [ngTemplateOutlet]="messageFormTmpl"
            [ngTemplateOutletContext]="{ minWidth: rect.width }"
          ></ng-template>
        </ng-template>
      </ng-container>
    </button>
  </ng-container>
</ng-container>
<ng-template #messageFormTmpl let-minWidth="minWidth">
  <app-inquiry-message-form
    #editor
    [inquiry]="inquiry"
    [guest]="guest"
    [draftMessage]="draftMessage"
    (close)="closeMessageForm()"
    (popup)="onPopup()"
    cdkDrag
    [cdkDragDisabled]="!isMessageFormPopup"
    [isPopup]="isMessageFormPopup"
    [minEditorHeight]="isMessageFormPopup ? 300 : 150"
    [maxEditorHeight]="isMessageFormPopup ? 800 : 500"
    [style.min-width.px]="minWidth"
    [style.width.px]="minWidth"
  >
  </app-inquiry-message-form>
</ng-template>
